//Componentes generales
import React, { useState, useContext, useEffect } from 'react';
import { FixedSizeList } from 'react-window';

//Componentes generales
import SearchInput from '../../components/searchInput/SearchInput';
import StateChange from '../../components/StateChange/StateChange';
import ReqInfo from '../ReqInfo/ReqInfo';
import FilterScreen from '../filterScreen/FilterScreen';
import AddFilter from '../addFilter/AddFilter';
import FormReq from '../FormReq/FormReq';
import RenderRow from '../renderRows/RRReqs';
import windowSizeContext from '../../context/windowSize/windowSizeContext';

//Estilos
import './ReqList.css';

//Fecha y hora formateadas
import { getNewFormattedDate } from '../../utils/formatDate';
import { ENTORNO } from '../../config/config';

//Context
import controlContext from '../../context/control/controlContext';
import authContext from '../../context/authentication/authContex';
import normalizeText from '../../utils/normalizeText';

/* 
    Componente encargado de mostrar el listado de requerimientos.
        Donde currentUser es el usuario en sesión.
              listTDoc es la lista de requerimientos.
              modificarEstado es la función del context encargarda de realizar una modificación de un campo especifico.
              verDetalle es la función que recupera el detalle de un requerimiento.
              filtros es el filtro donde se aplican las modificaciones por el usuario.
              aplicarFiltros es la función del context que aplica los filtros.
              generaPDF es la función del context que genera y descarga un archivo pdf.
              checkPermisos es la función del context que chequea si el usuario en sesión tiene permisos.
              guardarComo es la función del context encargada de guardar un requerimiento generado por un "repetir".
              editar es la función del context encargada de guardar un requerimiento generado por un "editar".
              eventoClickEdicion en la función del context que recupera los datos de un requerimiento a editar.
              recuperaFilesDetalle es la función del context que recupera los archivos de un requerimiento.
              sendToAPI es la función del context que envia la solicitud de enviar el requerimiento a Softland.
*/
function ReqList({
  currentUser,
  listTDoc,
  userListView,
  reqsSectorsList,
  modificarEstado,
  verDetalle,
  filtros,
  aplicarFiltros,
  generaPDF,
  checkPermisos,
  guardarComo,
  editar,
  eventoClickEdicion,
  recuperaFilesDetalle,
  sendToAPI,
  countPendientes,
}) {
  //state para marcar el requerimiento seleccionado.
  const [selected, setSelected] = useState('');
  //state para mostrar dialog de Edición.
  const [selectedEdit, setSelectedEdit] = useState('');
  //state para mostrar dialog de cambio de Estado.
  const [selectedState, setSelectedState] = useState('');
  //state para mostrar dialog de filtro.
  const [selectedFilter, setSelectedFilter] = useState('');
  //state para mostrar dialog de formulario requerimiento (guardar como).
  const [selectedRepeat, setSelectedRepeat] = useState('');
  /*state para deshabilitar las solapas de Órdenes de Compra/Requerimientos hasta que termine de cargar el 
  componente con los comprobantes */
  const [disabledElements, setDisabledElements] = useState(true);
  //state para saber si se modificaron los filtros
  const [filtrosModificados, setFiltrosModificados] = useState(false);
  //state para filtros.
  const [filter, setFilter] = useState('');

  //activeWorkSpace y setActiveWorkSpace ahora vienen del contexto de control

  //state para definir estados no enviables.
  const [stateNoEnviables, setStatesNoEnviable] = useState([
    'PENDIENTE',
    'EN ESPERA',
    'RECHAZADO',
    'ANULADO',
  ]);

  //state para definir tamaño para lista.
  const [itemSize, setItemSize] = useState(330);

  //Context control requerimientos
  const cContext = useContext(controlContext);
  const { iniciarFiltros, activeWorkSpace, setActiveWorkSpace } = cContext;

  //Context auth
  const aContext = useContext(authContext);
  const { usuario } = aContext;

  // Calcula el valor del height según el tamaño de la pantalla y el tamaño del navbar
  const wSContext = useContext(windowSizeContext);
  let { height } = wSContext;

  useEffect(() => {
    const fn = async () => {
      await handlerIniciarlizarFiltros(activeWorkSpace);
    };
    fn();
  }, []);

  useEffect(() => {
    const fn = async () => {
      const workSpace = {
        pendientes: 1,
        autorizados: 0,
        todos: 0,
      };
      setActiveWorkSpace(workSpace);
      await handlerIniciarlizarFiltros(workSpace);
    };
    fn();
  }, [usuario]);

  const handlerIniciarlizarFiltros = async activeWorkSpace => {
    setDisabledElements(true);
    await iniciarFiltros(activeWorkSpace, usuario);
    setTimeout(() => {
      setDisabledElements(false);
    }, 1000);
  };

  /* 
    Manejador que setea el  filtro de busqueda.
    Donde data es lo ingresado por el usuario.
  */
  const handdlerSearchInput = data => {
    setFilter(data);
  };

  /* 
    Manejador que abre/cierra dialog de información del requerimiento seleccionado.
    Donde item es el requerimiento seleccionado.
    En este punto, se recuperan los archivos adjuntados al requerimiento.
    */
  const handlerDetails = async item => {
    setSelected(null);
    if (item) {
      const files = await recuperaFilesDetalle(item, 'adjunto');
      const comprobantePdf = await recuperaFilesDetalle(
        item,
        'comprobante-pdf'
      );
      setSelected({ item, files, comprobantePdf });
    }
  };

  /* 
    Función encargada de mostrar el dialog de formulario de requerimiento.
    Donde item es el requerimiento del que se hace un guardar como.
    prods es la lista de productos del requerimiento.
    agregaItemF es la función de agrega itm (No esta en uso).
    Se setea el estado del requerimiento como pendieente y se agrega al titulo el prefijo "Copia" junto al numero del requerimiento repetido.
  */

  const repeat = async (item, prods, accountingProrations = [], clientProrations = []) => {
    const codDimTipoCosto = ENTORNO?.toLowerCase().includes('casport') ? 'TIPCOS' : 'TCC';
    const codDimCentroCosto = ENTORNO?.toLowerCase().includes('casport') ? 'CTRCTO' : 'CCO';
    const norm = (s) => s?.replace(/\s+/g, '') ?? '';
    setSelectedRepeat(null);
    if (item) {
      const { tDocCodFor, tDocNroFor, _id, title, ...rest } = item;
      const nuevaListaP = prods.map(p => {
        const { _id, ...prodSinId } = p;
        const nroItm = prodSinId.nroItm;
        const tipoCostoAP = accountingProrations.find(ap => ap.productNroItm === nroItm && norm(ap.codDim) === codDimTipoCosto);
        const tipoCostoCP = clientProrations.find(cp => cp.proContNroItm === nroItm && norm(cp.codDim) === codDimTipoCosto);
        const centroCostoAP = accountingProrations.find(ap => ap.productNroItm === nroItm && norm(ap.codDim) === codDimCentroCosto);
        const centroCostoCPs = clientProrations.filter(cp => cp.proContNroItm === nroItm && norm(cp.codDim) === codDimCentroCosto);

        const tipoCosto = tipoCostoCP ? {
          abmCodDim: tipoCostoCP.codDim?.trim(),
          abmCodDimDescrp: tipoCostoAP?.codDimDescrp?.trim() || '',
          abmCodDis: tipoCostoAP?.codDis?.trim() || '',
          abmCodDisDescrp: tipoCostoAP?.codDisDescrp?.trim() || '',
          abmSubCue: tipoCostoCP.subCue?.trim(),
          abmSubCueDescrp: tipoCostoCP.subCueDescrp?.trim(),
        } : undefined;

        let centroCostoDistribucion = undefined;
        if (centroCostoCPs.length > 0) {
          const hasDistribucion = !!centroCostoAP?.codDis?.trim();
          centroCostoDistribucion = {
            tipo: hasDistribucion ? 'distribucion' : 'manual',
            distribucion: hasDistribucion ? {
              codDim: centroCostoAP.codDim?.trim(),
              codDimDescrp: centroCostoAP.codDimDescrp?.trim() || '',
              codDis: centroCostoAP.codDis?.trim(),
              codDisDescrp: centroCostoAP.codDisDescrp?.trim() || '',
            } : null,
            subcuentas: centroCostoCPs.map(cp => ({ subCue: cp.subCue?.trim(), subCueDescrp: cp.subCueDescrp?.trim(), cantidad: parseFloat(cp.cantidad) || 0, porcen: cp.porcen })),
            filasSubcuentas: hasDistribucion ? [] : centroCostoCPs.map((cp, i) => ({ id: `loaded-${i}`, subCue: cp.subCue?.trim(), subCueDescrp: cp.subCueDescrp?.trim(), cantidad: String(parseFloat(cp.cantidad) || 0) })),
          };
        }

        return {
          ...prodSinId,
          ...(tipoCosto !== undefined && { tipoCosto }),
          ...(centroCostoDistribucion !== undefined && { centroCostoDistribucion }),
        };
      });

      setSelectedRepeat({
        item: {
          ...rest,
          title: `Copia ${tDocCodFor}-${tDocNroFor}`,
          state: 'PENDIENTE',
          enviado: false,
          fecAlt: getNewFormattedDate(),
          fecMod: getNewFormattedDate(),
          notePriv: '',
          notePubl: '',
          observ: '',
          observStateChange: '',
          fchAut: null,
          usrAut: '',
        },
        nuevaListaP,
      });
    }
  };

  /* 
    Manejador que abre/cierra el dialog de formulario en modo guardar como.
    Donde item es el requerimiento.
  */
  const handlerRepeat = async item => {
    setSelectedRepeat(null);
    if (item) {
      setSelectedRepeat(item);
      guardarComo(item);
    }
  };

  /* 
    Manejador que abre/cierra el dialog de formulario en modo edición.
    Donde req es el requerimiento a editar.
    agregaItemF es la función de agrega itm (No esta en uso).
    En este punto se recuperan los items y archivos.
  */

  const handlerEdit = async (req, agregaItemF) => {
    setSelectedEdit(null);
    if (req) {
      const { items, files } = await eventoClickEdicion(req);
      const { ...rest } = req;
      const nuevaListaP = items.map(p => {
        const { ...rest } = p;
        return rest;
      });

      setSelectedEdit({
        req: { ...rest },
        nuevaListaP,
        agregaItemF,
        files,
      });
    }
  };

  /* 
    Manejador que abre/cierra el dialog de cambio de estado.
    Donde item es el requerimiento.
  */
  const handlerState = async item => {
    setSelectedState(item);
  };

  /* 
    Manejador que abre/cierra el fialog de filtros.
    Donde itm es un booleano que determina si se ve o no.
  */
  const handlerClickFilter = itm => {
    setSelectedFilter(itm);
  };

  /* 
    Manejador encargado de abrir en una nueva ventana el archivo seleccionado.
  */
  const handlerAbrirURL = url => {
    window.open(url);
  };

  const handleWorkSpace = async statusToDisplay => {
    setFilter('');
    let workspaceToSet =
      statusToDisplay == 'todos'
        ? { todos: 1, autorizados: 0, pendientes: 0, enEspera: 0 }
        : statusToDisplay == 'enEspera'
        ? { todos: 0, autorizados: 0, pendientes: 0, enEspera: 1 }
        : statusToDisplay == 'autorizados'
        ? { todos: 0, autorizados: 1, pendientes: 0, enEspera: 0 }
        : { todos: 0, autorizados: 0, pendientes: 1 };
    let estado =
      statusToDisplay == 'todos'
        ? ['PENDIENTE', 'RECHAZADO', 'AUTORIZADO', 'EN ESPERA', 'ANULADO']
        : statusToDisplay == 'pendientes'
        ? ['PENDIENTE']
        : statusToDisplay == 'enEspera'
        ? ['EN ESPERA']
        : ['AUTORIZADO'];
    setActiveWorkSpace(workspaceToSet);
    if (filtrosModificados === true) {
      await handlerIniciarlizarFiltros(workspaceToSet);
      setFiltrosModificados(false);
    } else {
      const filterEstado = { ...filtros.filtrosEstado, state: estado };
      const filterRango = filtros.filtrosRango;
      await aplicarFiltros({ filterRango, filterEstado }, '');
    }
  };

  return (
    <div>
      <div className="navbar-reqList">
        <div
          className={`${
            activeWorkSpace.pendientes
              ? 'navbar-container-reqList-active'
              : 'navbar-container-reqList'
          } ${disabledElements ? 'navbar-container-disabled' : ''}`}
          onClick={async () =>
            !disabledElements ? await handleWorkSpace('pendientes') : null
          }
        >
          <div className="navbar-item-reqList">
            <div className="navbar-item-label-top-xx">
              PENDIENTES
              {!disabledElements && (
                <span
                  className={
                    'badge ' +
                    (countPendientes > 0
                      ? 'badge-pendientes'
                      : 'badge-pendientes-ok')
                  }
                >
                  {countPendientes}
                </span>
              )}
            </div>
          </div>
        </div>
        <div
          className={`${
            activeWorkSpace.enEspera
              ? 'navbar-container-reqList-active'
              : 'navbar-container-reqList'
          } ${disabledElements ? 'navbar-container-disabled' : ''}`}
          onClick={async () =>
            !disabledElements ? await handleWorkSpace('enEspera') : null
          }
        >
          <div className="navbar-item-reqList">
            <div className="navbar-item-label-top-xx">EN ESPERA</div>
          </div>
        </div>
        <div
          className={`${
            activeWorkSpace.autorizados
              ? 'navbar-container-reqList-active'
              : 'navbar-container-reqList'
          } ${disabledElements ? 'navbar-container-disabled' : ''}`}
          onClick={async () =>
            !disabledElements ? await handleWorkSpace('autorizados') : null
          }
        >
          <div className="navbar-item-reqList">
            <div className="navbar-item-label-top-xx">AUTORIZADOS</div>
          </div>
        </div>
        <div
          className={`${
            activeWorkSpace.todos
              ? 'navbar-container-reqList-active'
              : 'navbar-container-reqList'
          } ${disabledElements ? 'navbar-container-disabled' : ''}`}
          onClick={async () =>
            !disabledElements ? await handleWorkSpace('todos') : null
          }
        >
          <div className="navbar-item-reqList">
            <div className="navbar-item-label-top-xx">TODOS</div>
          </div>
        </div>
      </div>
      <div className="container-requests-list">
        <FilterScreen
          verFiltro={handlerClickFilter}
          disabled={disabledElements}
        />
        <SearchInput
          defaultValue={filter}
          buscar={handdlerSearchInput}
        />

        {!disabledElements && (
          <FixedSizeList
            height={height - 300}
            style={{ flexGrow: 1 }}
            itemCount={
              filter === ''
                ? listTDoc.length
                : listTDoc.filter(
                    r =>
                      normalizeText(r.title).includes(normalizeText(filter)) ||
                      normalizeText(
                        r.tDocCodFor + ' - ' + r.tDocNroFor.toString()
                      ).includes(normalizeText(filter)) ||
                      normalizeText(r.tDocNroFor.toString()).includes(
                        normalizeText(filter)
                      )
                  ).length
            }
            itemSize={itemSize}
            width={'100%'}
          >
            {({ index, style }) => (
              <RenderRow
                currentUser={currentUser}
                index={index}
                style={style}
                listTDoc={listTDoc}
                filter={filter}
                checkPermisos={checkPermisos}
                cambiarEstado={handlerState}
                editar={handlerEdit}
                verDetalles={handlerDetails}
                statesNEviables={stateNoEnviables}
                sendToAPI={sendToAPI}
                guardarEstado={(r, state, observStateChange) =>
                  modificarEstado(r, { state: state, observStateChange: observStateChange })
                }
                cerrar={handlerState}
                disabledElements={disabledElements}
              />
            )}
          </FixedSizeList>
        )}
      </div>
      {selectedFilter && (
        <div className="modalReq">
          <AddFilter
            usuarios={userListView}
            sectoresRequerimientos={reqsSectorsList}
            item={selectedFilter}
            cerrar={handlerClickFilter}
            filtro={filtros}
            aplicarFiltros={aplicarFiltros}
            setFiltrosModificados={setFiltrosModificados}
            workspace={activeWorkSpace}
          />
        </div>
      )}
      {selected && (
        <div className="modalReq">
          <ReqInfo
            item={selected.item}
            files={selected.files}
            comprobantePdf={selected.comprobantePdf}
            cerrar={handlerDetails}
            verDetalle={verDetalle}
            repetir={repeat}
            generaPDF={generaPDF}
            abrirURL={handlerAbrirURL}
            guardarModificaciones={modificarEstado}
            usuario={currentUser}
            checkPermisos={checkPermisos}
          />
        </div>
      )}
      {selectedRepeat && (
        <div className="modalReq">
          <FormReq
            edicion={'Guardar_Como'}
            req={selectedRepeat.item}
            itemList={selectedRepeat.nuevaListaP}
            guardarReq={guardarComo}
            cerrar={handlerRepeat}
            verDetalle={verDetalle}
          />
        </div>
      )}
      {selectedEdit && (
        <div className="modalReq">
          <FormReq
            edicion={'Edicion'}
            req={selectedEdit.req}
            itemList={selectedEdit.nuevaListaP}
            files={selectedEdit.files}
            guardarReq={editar}
            cerrar={handlerEdit}
            verDetalle={verDetalle}
          />
        </div>
      )}
      {selectedState && (
        <div className="modalReq">
          <StateChange
            item={selectedState}
            verDetalle={verDetalle}
            guardarEstado={(r, state, observStateChange) => modificarEstado(r, { state: state, observStateChange: observStateChange })}
            cerrar={handlerState}
            checkPermisos={checkPermisos}
          />
        </div>
      )}
    </div>
  );
}

export default ReqList;